import { Component, HostBinding, Input } from "@angular/core"
import { ErrorCode } from "../error-code.model"
import { CHNode } from "../../models/node.model"
import { LearningObject } from "../../models/learningObject.model"

@Component({
    selector: "app-unauthorized-error",
    templateUrl: "./unauthorized-error.component.html",
    styleUrls: ["./unauthorized-error.component.scss"],
})
export class UnauthorizedErrorComponent {
    public image: string
    public ErrorCode = ErrorCode

    @HostBinding("style") hostBinding = "flex: 1"

    @Input()
    public nextURL: string

    @Input()
    public errorCode: ErrorCode

    @Input()
    public isStudent: boolean

    @Input()
    public errorMessage: string

    @Input()
    public showContent: boolean = false

    @Input()
    public subjects: CHNode[] = []

    @Input()
    public learningObjects: LearningObject[] = []

    constructor() {
        this.image = require("../../../assets/Lost-in-Space.png").default
    }
}
